/* @flow */
const IMPORT_HISTORY_PREF_KEY: string = 'fleetLocate.importHistory';
export default IMPORT_HISTORY_PREF_KEY;
